// @scripts
 import CategoryPageContainer from '../CategoryPage/CategoryPageContainer';
 import CandidateGridContainer from '../CandidateGrid/CandidateGridContainer';
 import ScheduleContainer from '../ScheduleView/ScheduleContainer';
 //import CtrlHeader from './header';

// @constants
const components = {
     CategoryPageContainer,
     CandidateGridContainer,
     ScheduleContainer,
   //  CtrlHeader,
};

/**
 * @param {string} componentName
 * @returns {function}
 */
export const mapComponent = (componentName) => components[componentName];
